import { css } from "styled-components";
import { colors } from "./colors";

export const whiteRoundedBlockStyle = css`
	background-color: ${colors.white};
	border-radius: 10px;
`;

export const containerStyles = {
	roundedBlockStyle: css`
		background-color: ${({ theme }) => theme.colors.white};
		border: solid 1px ${({ theme }) => theme.colors.lightergray};
		border-radius: 13px;
	`,
} as const;

export type ContainerStyles = typeof containerStyles;
